import React, { useState } from 'react';
import { faAngleLeft, faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Row } from 'reactstrap';

//Components
import MainCard from '../../../../../components/MainCard';
import TextField from '../../../../../components/TextField';

//Helpers
import { getSessionCookie } from '../../../../../helpers/cookies';
import { objCampo, validarCampos } from '../../../../../helpers/ValidadorDeCampos';
import mascaras from '../../../../../helpers/mascaras';
import cep_api from '../../../../../api/cep_api';
import { showMessage } from '../../../../../helpers/message';
import { useAuth } from '../../../../../context/auth';
import { useEffect } from 'react';
import contratadas_api from '../../../../../api/contratadas_api';

function initialStateContratada(secretaria_Id) {
    return {
        razaoSocial: "",
        cnpj: "",
        nomeResponsavel: "",
        email: "",
        cep: "",
        logradouro: "",
        numero: "",
        bairro: "",
        cidade: "",
        uf: "",
        secretaria_Id: secretaria_Id,
    }
}

function CadastroContratadas({ id, handleVoltar, editavel }) {
    const session = getSessionCookie();

    //State para criar/editar contratada
    const [contratada, setContratada] = useState(initialStateContratada(session.secretaria_Id));

    //State para pegar erros
    const [errors, setErrors] = useState({});

    const { setLoading } = useAuth();

    const loadContradata = (id = null) => {
        if (id != null || contratada?.id != null) {
            setLoading(true);
            contratadas_api.getItem(id ?? contratada?.id)
                .then(response => setContratada(response.data))
                .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
                .finally(() => setLoading(false));
        }
    }

    useEffect(() => {
        loadContradata(id);
    }, []);

    //Campos obrigatorios
    const campos = [
        objCampo({ name: "razaoSocial", required: true }),
        objCampo({ name: "cnpj", required: true, cnpj: true }),
        objCampo({ name: "nomeResponsavel", required: true }),
        objCampo({ name: "email", required: true }),
        objCampo({ name: "cep", required: true }),
        objCampo({ name: "logradouro", required: true }),
        objCampo({ name: "bairro", required: true }),
        objCampo({ name: "cidade", required: true }),
        objCampo({ name: "uf", required: true })
    ];


    const onChange = (e) => {
        const { name, value } = e.target;
        const _contratada = {
            ...contratada,
            [name]: value
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_contratada, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setContratada(_contratada);
    }

    const onblurContratada = (e) => {
        if (e.target.value.length < 9) return;

        setLoading(false)
        cep_api.get(e.target.value)
            .then(response => {
                setContratada({
                    ...contratada,
                    logradouro: response.data.logradouro,
                    bairro: response.data.bairro,
                    cidade: response.data.localidade,
                    uf: response.data.uf
                })
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    }

    const onSumitContratada = () => {
        const _errors = validarCampos(contratada, campos);
        setErrors(_errors[0]);

        if (_errors[1].length > 0)
            return true;

        const _contratada = { ...contratada };

        if (_contratada.id) {
            setLoading(true);
            contratadas_api.put(_contratada)
                .then(response => {
                    showMessage("Sucesso", "Sucesso na operação.", "success", handleVoltar)
                })
                .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", () => handleVoltar()))
                .finally(() => setLoading(false));
        } else {
            setLoading(true);
            contratadas_api.post(_contratada)
                .then(response => {
                    showMessage("Sucesso", "Sucesso na operação.", "success", handleVoltar)
                })
                .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", () => handleVoltar()))
                .finally(() => setLoading(false));
        }
    }

    return <>
        <Button onClick={() => {
            handleVoltar()
        }} className='px-4'>
            <FontAwesomeIcon icon={faAngleLeft} className='me-2' />
            Voltar
        </Button>
        <MainCard>
            <h5 style={{ color: "#666" }}>Cadastro de Contratada</h5>
            <Row className=''>
                <Col md={12} lg={4}>
                    <TextField
                        name={"razaoSocial"}
                        label={"* Razão social"}
                        type={"text"}
                        value={contratada.razaoSocial}
                        onChange={onChange}
                        invalid={errors.razaoSocial}
                        disabled={!editavel}
                        maxLength={200}
                    />
                </Col>
                <Col md={12} lg={4}>
                    <TextField
                        name={"nomeResponsavel"}
                        label={"* Nome responsável"}
                        type={"text"}
                        value={contratada.nomeResponsavel}
                        onChange={onChange}
                        maxLength={100}
                        invalid={errors.nomeResponsavel}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={4}>
                    <TextField
                        name={"cnpj"}
                        label={"* CNPJ"}
                        type={"text"}
                        mask={mascaras.cnpjMask}
                        value={contratada.cnpj}
                        onChange={onChange}
                        invalid={errors.cnpj}
                        disabled={!editavel}
                        maxLength={18}
                    />
                </Col>
                <Col md={12} lg={4}>
                    <TextField
                        name={"email"}
                        label={"* E-mail"}
                        type={"text"}
                        value={contratada.email}
                        onChange={onChange}
                        invalid={errors.email}
                        disabled={!editavel}
                        maxLength={150}
                    />
                </Col>
                <Col md={12} lg={3}>
                    <TextField
                        type={"text"}
                        mask={mascaras.cepMask}
                        name={"cep"}
                        label={"* CEP"}
                        value={contratada.cep}
                        onBlur={onblurContratada}
                        onChange={onChange}
                        maxLength={9}
                        invalid={errors.cep}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={3}>
                    <TextField
                        type={"text"}
                        name={"cidade"}
                        label={"* Cidade"}
                        value={contratada.cidade}
                        onChange={onChange}
                        maxLength={150}
                        invalid={errors.cidade}
                        disabled={!editavel}
                    />
                </Col>

                <Col md={12} lg={2}>
                    <TextField
                        type={"text"}
                        name={"uf"}
                        label={"* UF"}
                        value={contratada.uf}
                        onChange={onChange}
                        maxLength={2}
                        invalid={errors.uf}
                        disabled={!editavel}
                    />
                </Col>

                <Col md={12} lg={4}>
                    <TextField
                        type={"text"}
                        name={"bairro"}
                        label={"* Bairro"}
                        value={contratada.bairro}
                        onChange={onChange}
                        maxLength={150}
                        invalid={errors.bairro}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={6}>
                    <TextField
                        type={"text"}
                        name={"logradouro"}
                        label={"* Logradouro"}
                        value={contratada.logradouro}
                        onChange={onChange}
                        maxLength={150}
                        invalid={errors.logradouro}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={2}>
                    <TextField
                        type={"text"}
                        name={"numero"}
                        label={"* Numero"}
                        value={contratada.numero}
                        onChange={onChange}
                        maxLength={10}
                        disabled={!editavel}
                    />
                </Col>

                <Col md="12" lg="12" className={`d-flex align-items-center justify-content-center ${editavel ? "" : "d-none"}`}>
                    <Button
                        className='px-4'
                        color={contratada.id ? 'warning text-white' : 'success'}
                        onClick={onSumitContratada}>{contratada.id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : "+ Cadastrar"}
                    </Button>
                </Col>
            </Row>
        </MainCard>
    </>;
}

export default CadastroContratadas;